import React from "react"

type ContentParagraphProps = {
  children: React.ReactNode
}

export function ContentParagraph({ children }: ContentParagraphProps) {
  return (
    <p className="text-center font-inter text-18 font-light leading-6 text-white md:text-left md:text-24">
      {children}
    </p>
  )
}
